import { Label, Panel, PanelType, PrimaryButton } from "@fluentui/react";
import Alert from '@mui/material/Alert';
import { ICourseProgram, ICourseType } from "./DataTable";
import { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { getCourseTypes, updateCourseContent } from "../api";
import "../styles/PricePanel.css";

export default function DurationPanel(props: { courseType: ICourseType, program: ICourseProgram, onDismiss: () => void; }): JSX.Element {
    const [courseType, setCourseType] = useState<ICourseType | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const inputDuration = useRef<HTMLInputElement>(null);
    const { instance, accounts } = useMsal();
    const [token, setToken] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            setToken(response.accessToken);
        });
    }, [props])

    useEffect(() => {
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            if (props.program) {
                getCourseTypes(response.accessToken, props.program?.programnavnID).then((data: any) => {
                    const type = data.data.find((type: any) => type.kursusTitel === props.courseType.kursusTitel);
                    setCourseType(type);
                    setIsLoading(false);
                })
            }
        });
    }, []);

    const onUpdateDuration = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (inputDuration.current?.value !== "" && inputDuration.current?.value !== undefined) {

            try {
                if(courseType){
                    const newTypeObj: ICourseType = {
                        ...props.courseType,
                        kursusTitel: props.courseType.kursusTitel,
                        kursustypeID: props.courseType.kursustypeID,
                        pris: courseType.pris,
                        programnavnID: props.program.programnavnID,
                        varighed:parseFloat(inputDuration.current?.value),
                        indhold: courseType.indhold,
                        duLaerer: courseType.duLaerer,
                        duBoer: courseType.duBoer,
                        duFaar: courseType.duFaar,
                        indledning: courseType.indledning,
                        kursusmateriale: courseType.kursusmateriale,
                        kursusmål: courseType.kursusmål,
                        deltagere: courseType.deltagere,
                    }
                 
                    await updateCourseContent(token, newTypeObj);
                    setCourseType(newTypeObj);
                }
                
            } catch (error) {
                console.log(error);
            }
        } else {
            setError("Input feltet er tom");
        }


    }

    return (
        <Panel
            headerText={props?.courseType.kursusTitel}
            type={PanelType.smallFixedFar}
            isOpen={props !== null}
            onDismiss={() => props.onDismiss()}
            // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
            closeButtonAriaLabel="Close"
            className="pricePanel"
        >
            <p>Administrer kursets varighed</p>
            {!isLoading && courseType !== null && (
                <div className="container">
                    <div className="priceInfoContainer">
                        <Label htmlFor="priceInfo">Varighed:</Label>
                        {courseType.varighed === null ? (
                            <span className="price" id="priceInfo">0 kr.</span>
                        ) : (
                            <span className="price" id="priceInfo">{courseType.varighed} {"dag(e)"}</span>
                        )}

                    </div>

                    <form>
                        <Label htmlFor='newPrice'>Ny Varighed:</Label>
                        <div className="inputContainer">
                            <input ref={inputDuration} type='number' id="newPrice" onClick={ev => setError("")}/>
                            <PrimaryButton className="btnSave" onClick={onUpdateDuration}>Gem</PrimaryButton>
                        </div>

                    </form>
                    {error != "" && (
                        <Alert severity="warning">{error}</Alert>
                    )}


                </div>

            )}


        </Panel>
    )
}
